import { useState } from "react";
import { RequestError, useApi } from "../../services";
import {
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid2,
} from "@mui/material";
import { ErrorOnDialog } from "./errorModal";
import { BarragemData, BarragemImage } from "../../context";
import { FileUpload } from "../fileUpload";
import { DeleteForever } from "@mui/icons-material";
import { ConfirmModal } from "./confirmModal";

interface ImagesBarragemProps {
  open: boolean;
  barragem: BarragemData;
  onBarragem?: (barragem: BarragemData) => void;
  onCancel?: () => void;
}

export const ImagesBarragemModal: React.FC<ImagesBarragemProps> = ({
  open,
  barragem,
  onCancel,
}) => {
  const api = useApi();

  const [imgAdd, setImgAdd] = useState<File[]>();
  const [error, setError] = useState<RequestError>();
  const [imgShow, setImgShow] = useState<BarragemImage[]>(barragem.images);

  const handleRemove = async (img: BarragemImage) => {
    const result = await api.barragem.removeImage(barragem.id, img);
    if ("error" in result) {
      setError(result);
      return;
    }

    setImgShow(imgShow.filter((_img) => _img.id !== img.id));
  };

  const handleAdd = async () => {
    if (!imgAdd) return;

    for (const img of imgAdd) {
      const result = await api.barragem.addImage(barragem.id, img);
      if ("error" in result) {
        setError(result);
        return;
      }
      setImgShow((prev) => prev.map(img => img.id === result.id ? result : img));
      setImgAdd(undefined);
    }
  };

  const handleCancel = () => {
    if (onCancel) onCancel();
  };

  return <>
    {error && <ErrorOnDialog
      open={Boolean(error)}
      onClose={() => setError(undefined)}
      {...error}
    />}

    <Dialog
      fullWidth
      open={open}
      maxWidth={"md"}
      onClose={handleCancel}
    >
      <DialogTitle id="alert-dialog-title">Adicionar Imagens</DialogTitle>

      <DialogContent>
        <Divider />
        <div style={{ height: "1em" }} />

        {/* Textos e upload*/}
        <Box sx={{
          flex: 1,
          gap: "0.5em",
          display: "flex",
          flexDirection: "row",
        }}>
          <Box sx={{
            width: "33em",
            maxHeight: "60vh",
            overflow: "auto",
          }}>
            <Grid2 container spacing={"1em"}>
              {imgShow.map((img, id) => {
                return <Grid2
                  key={id}
                  size={6}
                >
                  <ImageItem
                    url={img.url}
                    onRemove={() => handleRemove(img)}
                  />
                </Grid2>;
              })}
            </Grid2>
          </Box>
          <Box sx={{
            flex: 1,
            gap: "0.5em",
            display: "flex",
            flexDirection: "column",
          }}>
            {imgAdd && <Button
              fullWidth
              variant="contained"
              onClick={() => handleAdd()}
            >
              Adicionar Imagens
            </Button>}

            <FileUpload
              multiple
              sx={{ flex: 1 }}
              files={imgAdd}
              onAddFile={setImgAdd}
            />
          </Box>
        </Box>
      </DialogContent>


      <DialogActions>
        <Button variant="contained" onClick={handleCancel}>
          Finalizar
        </Button>
      </DialogActions>
    </Dialog >
  </>;
};

interface ImageItemProps {
  url: string;
  onRemove: (url: string) => void;
}
const ImageItem: React.FC<ImageItemProps> = ({
  url,
  onRemove,
}) => {

  const [open, setOpen] = useState(false);

  return <>
    <ConfirmModal
      open={open}
      title="Deseja excluir esta imagem?"
      message="Esta ação é irreversível!"
      onCancel={() => setOpen(false)}
      onConfirm={() => {
        onRemove(url);
        setOpen(false);
      }}
    />
    <Card
      onClick={() => setOpen(true)}
      sx={{
        width: `15em`,
        height: `15em`,
        display: "flex",
        cursor: "pointer",
        '&:hover': { boxShadow: 15 },
      }}
    >
      {/* Imagem */}
      <Box sx={{
        position: 'relative',
        width: '100%',
        height: '100%',
        display: "flex",
        flexDirection: "column",
      }}>
        <img
          src={url}
          style={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            objectFit: 'cover',
          }} />

        <DeleteForever sx={{
          color: "white",
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          fontSize: 52
        }} />
      </Box>
    </Card >
  </>;
};